<template>
  <div class="materialPayTypeSubscript" v-show="showWho !== 'free'">
    <div :class="[IsOldUser ? 'commonVip' : 'pro']" v-if="showWho == 'sceneAnimation' || showWho === 'artword'">
    </div>
    <template v-else>
      <div :class="getBadgeClassName(4, 'enterpriseS')" v-if="showWho == 'enterpriseS'">
       <span class="words">  </span>
      </div>
      <div class="commonVip" v-if="showWho == 'commonVip'">
       <span class="words"> VIP </span>
      </div>
      <div :class="getBadgeClassName(6, 'companyVip')" v-else-if="showWho == 'companyVip'" >
        <span class="words">企业VIP</span>
      </div>
      <div class="bought" v-else-if="showWho == 'bought'" >
        <span class="words">已购买</span>
      </div>
      <span class="price" v-else-if="showWho == 'price'">￥{{ item.price }}</span>
      <span class="discount" v-else-if="showWho == 'discount'"
        >￥{{ item.price }}</span
      >
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vipBadge from '@/components/mixins/vipBadge';
export default {
  name: "materialPayTypeSubscript",
  mixins: [vipBadge],
  components: {},
  props: {
    localType: '',
    item: {
      default () {
        return {
          payType: 0,
          price: 0,
        }
      }
    },
  },
  data() {
    return {};
  },
  created(){
  },
  computed: {
    ...mapGetters(["UserLevelType", 'IsOldUser']),
    showWho: function () {
      if (this.localType === 'artword') {
        return this.localType;
      }
      const className = this.getBadgeClassName(4, 'kkk')
      console.log(`Turbo ~ className:`, className)
      let type = (this.item || {}).payType;
      let tt = this.item.tt;
      if (tt) {
        return 'bought'
      } else {
        if (type === 0) {
          return "free";
        }
        else if ((type === 1 || type === 2 || type === 3) && this.UserLevelType < 3) {
          if (tt) {
            return "bought";
          } else {
            return 'price';
          }
        }
        else if (type === 4) {
          if (this.IsOldUser) {
            return "commonVip";
          }
          return 'enterpriseS';
        } else if (type === 6) {
          return "companyVip";
        } else if (type === 8) {
          return 'price'
        } else {
          return "free";
        }
      }
    },
  },
  watch: {},
  methods: {},
};
</script>

<style scoped lang="scss">
.materialPayTypeSubscript {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.free {
  display: none;
}
.words {
  color: #fff;
  font-size: 12px;
  transform: scale(0.8);
  position: relative;
  top: -3px;
}
.price,
.discount {
  background: linear-gradient(108deg, #fa2efc 0%, #325eff 99%);
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
  padding: 0 6px;
}
.bought {
  width: 50px;
  height: 16px;
  // background: linear-gradient(352deg, #01ACCB 0%, #5DE3C2 100%);
  content: url("../../../static/svg/payTypeSubscript/AlreadyPay.svg");

  // border-radius: 8px;
}
.commonVip {
  width: 36px;
  height: 16px;
  // background: linear-gradient(122deg, #FABE63 0%, #E74500 100%);
  content: url("../../../static/svg/payTypeSubscript/commonVip.svg");

  // border-radius: 8px;
}
.companyVip {
  width: 50px;
  height: 16px;
  // background: linear-gradient(352deg, #2F58FE 0%, #49A6FC 100%);
  content: url("../../../static/svg/payTypeSubscript/companyVip.svg");
  // border-radius: 8px;
}
.enterpriseS {
  width: 50px;
  height: 16px;
  // content: url(../../assets/enterpriseS.png);
  content: url(../../assets/enterpriseSVIP.svg);
}
.pro {
  width: 30px;
  height: 18px;
  content: url(../../assets/pro.png);
}
.proPlus {
  width: 32px;
  height: 18px;
  content: url(../../assets/proPlus.png);
}
</style>



// WEBPACK FOOTER //
// src/components/common/materialPayTypeSubscript.vue